<template>
<div class="menu-list">
 <h2>买家中心</h2>
  <a-menu  :selectedKeys="selectedKeys" mode="inline" theme="light">
    <a-menu-item v-for="(item) in menu" :key="item.route">
        <router-link :to="item.route + ($route.query.entityId && `?entityId=${$route.query.entityId}`)">
              {{item.menuName}}
        </router-link>
    </a-menu-item>
  </a-menu>
</div>
</template>

<script>
import {mapGetters} from 'vuex'
import {piaConfig} from '@/api/buyer'
export default {
    data() {
        return {
            selectedKeys: [],
            menu: []
        };
    },
    computed: {
        ...mapGetters(['getRoleP']),
        list() {
            const menu = this.getRoleP.find(item => item.entityId == this.$route.query.entityId)
            if (menu) {
                const obj = {
                    "PM001": '/buyercenter',
                    "PM002": '/buyercenter/order-management',
                    "PM003": '/buyercenter/advance-management',
                    "PM004": '/buyercenter/payment-management',
                    "PM005": '/buyercenter/balance-management',
                    "PM006": '/buyercenter/batch-management',
                    "PM007": '/buyercenter/downstream',
                    "PM008": '/buyercenter/stock',
                }
                return menu.menuListVoList.map(item => (({ ...item, route: obj[item.menuCode]})))
            }
            return []
        }
    },
    mounted () {
        console.log(222);
        this.updateMenu()
        this.piaConfig()
    },
    watch: {
    '$route' () {
        this.updateMenu()
        }
    },
    methods: {
        piaConfig() {
            piaConfig({purchaserId: this.$route.query.entityId}).then(res => {
                console.log(res);
                this.menu = this.list.map(i => ({...i}))
                if (res.data.metricValue === 'YES') {
                    this.menu.splice(3,0,{menuName: '预付货款', route: '/buyercenter/advance-management'})
                }
            })
        },
        handleClick() {
        this.updateMenu()
        },
        updateMenu () {
            const routes = this.$route.matched.concat()
            this.selectedKeys = [ routes.pop().path ]
        }
    }
}
</script>

<style lang="less" scoped>
.menu-list {
    box-sizing: border-box;
    width: 250px;
    background-color: #fff;
    border-right: 1px solid #e8e8e8;
}
/deep/ .ant-menu-item {
    &:nth-child(1) {
        margin-top: 0;
    }
}
/deep/ .ant-menu-item {
    a {
        color: rgba(0, 0, 0, 0.65);
    }
}
/deep/ .ant-menu-item-selected {
    a {
        color: @primary;
    }
}
/deep/ .ant-menu-inline{
    border-right: none;
}
/deep/.ant-menu-item::after{
    position: absolute;
    top: 0;
    left: 0;
    border-left: 3px solid #60a830;
    border-right: none;
}
h2{
    padding: 20px;
    font-size: 18px;
    font-weight: 600;
    color: rgb(102, 102, 102);
}
</style>